module.exports = __webpack_public_path__ + "static/media/tipo-pepep.9fe5a32e.woff2";